import {
  FlagFragment,
  FlagQuery,
  FlagQueryVariables,
  FlagsDocument,
  useFlagQuery,
  useOnFlagCreatedSubscription,
  useOnFlagUpdatedSubscription,
  withStandardGetHook,
} from '@spotify/confidence-graphql';

const useFlagImpl = withStandardGetHook<
  FlagQuery, // TData (Full query result type)
  FlagFragment, // TItem (Type of item at dataPath)
  'flag', // TPath (Path to the item)
  FlagQueryVariables // TVariables (Query variables type)
>(useFlagQuery, 'flag');

export const useFlag: typeof useFlagImpl = options => {
  useOnFlagCreatedSubscription({
    onData: ({ client }) => {
      client.refetchQueries({
        include: [FlagsDocument],
      });
    },
    skip: options.skip,
  });

  useOnFlagUpdatedSubscription({
    skip: options.skip,
  });

  return useFlagImpl(options);
};
